import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  inputAutocomplete: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    '& .MuiAutocomplete-inputRoot': {
      padding: '0px 6px !important'
    },

    '& .MuiOutlinedInput-root': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gray_50.main,
      borderRadius: '8px',
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    },
    '& .MuiOutlinedInput-input': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    },
    '& span': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main,
      fontSize: '1rem',
      fontFamily: 'Inter, sans-serif',
      fontWeight: '400',
      lineWeight: '1'
    }
  },
  inputWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  }
}))
